import * as React from "react"

function MegaPhone({ fill, ...props }) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.549 10.82l-1.826 1.614a1.414 1.414 0 00-.288 1.77l1.653 2.9a1.404 1.404 0 001.662.63l2.297-.784-3.498-6.13z"
        stroke={fill || "#000"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.258 4.59a26.669 26.669 0 01-1.71 4.072 7.178 7.178 0 01-2 2.157l3.499 6.112a7.294 7.294 0 012.882-.668c1.464.066 2.92.25 4.353.552"
        stroke={fill || "#000"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.56 14.416l-.606.358a1.396 1.396 0 00-.69 1.412c.025.184.086.362.18.522a1.4 1.4 0 001.404.696c.183-.026.36-.088.519-.183l.567-.358m4.804-.203l1.7 2.97a1.44 1.44 0 01-.508 1.933 1.403 1.403 0 01-1.922-.522l-1.922-3.414m12.55-10.735l-2.498 1.45m4.612 3.531h-2.883M16.225 2.25l-1.442 2.515m-5.53-.174l1.215-.706a1.395 1.395 0 011.917.517l5.607 9.774a1.42 1.42 0 01-.52 1.92l-1.214.707L9.253 4.591z"
        stroke={fill || "#000"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MegaPhone
